import { css } from '@emotion/react'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { PhotoList, PhotoDisplay, Upload, Activity } from 'page';
import { BREAK_POINT_PHONE_TAB, PRIMARY_COLOR } from 'style'
import { useInitialFetchPhotos } from 'hooks/useInitialFetchPhotos';
import { ACTIVITY_PATH, ARTICLE_PATH, EDIT_PATH, HOME_PATH, PHOTO_DISPLAY_PATH, UPLOAD_PATH } from 'config';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ArticleList } from 'page/ArticleList';
import { AiFillHome, AiFillInstagram, AiFillPlusCircle, AiOutlineHome, AiOutlineInstagram, AiOutlinePlusCircle, AiOutlineBell, AiFillBell } from 'react-icons/ai'
import './font.css'
import { IconContext } from 'react-icons';
import { ArticleEdit } from 'page/ArticleEdit';
import { useEffect } from 'react';

function App() {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const checkUpdate = async () => {
      try {
        const res = await fetch('/version.json', { cache: 'no-store' });
        if (!res.ok) return;

        const { version: serverVersion } = await res.json();
        const localVersion = localStorage.getItem('app_version');

        if (!localVersion) {
          localStorage.setItem('app_version', String(serverVersion));
        }
      } catch (e) {
        console.error('Update check failed:', e);
      }
    };

    checkUpdate();
  }, []);

  useInitialFetchPhotos()

  const reload = () => {
    window.location.href = HOME_PATH
  }

  const homeIcon = location.pathname === '/index.html' || location.pathname === '/' ? (
    <AiFillHome />
  ) : (
    <AiOutlineHome />
  )

  const instaIcon = location.pathname === '/article' ? (
    <AiFillInstagram />
  ) : (
    <AiOutlineInstagram />
  )

  const plusIcon = location.pathname === '/upload' ? (
    <AiFillPlusCircle />
  ) : (
    <AiOutlinePlusCircle />
  )

  const bellIcon = location.pathname === '/activity' ? (
    <AiFillBell />
  ) : (
    <AiOutlineBell />
  )

  return (
    <div css={containerCss}>
      <header css={headerCss}>
        <div onClick={() => reload()} css={logoCss}>Insoutagram</div>
      </header>
      <main css={bodyCss}>
        <Routes>
          <Route path={HOME_PATH} element={<PhotoList />} />
          <Route path={PHOTO_DISPLAY_PATH} element={<PhotoDisplay />} />
          <Route path={ARTICLE_PATH} element={<ArticleList />} />
          <Route path={UPLOAD_PATH} element={<Upload />} />
          <Route path={EDIT_PATH + '/:id'} element={<ArticleEdit />} />
          <Route path={ACTIVITY_PATH} element={<Activity />} />
          <Route path="*" element={<PhotoList />} />
        </Routes>
      </main>
      <footer css={footerCss}>
        <IconContext.Provider value={{ color: "black", size: "2rem" }}>
          <div css={tabCss} onClick={() => navigate(HOME_PATH)}>{homeIcon}</div>
          <div css={tabCss} onClick={() => navigate(ARTICLE_PATH)}>{instaIcon}</div>
          <div css={tabCss} onClick={() => navigate(UPLOAD_PATH)}>{plusIcon}</div>
          <div css={tabCss} onClick={() => navigate(ACTIVITY_PATH)}>{bellIcon}</div>
        </IconContext.Provider>
      </footer>
      <ToastContainer
        position="top-center"
      />
    </div>
  );
}

const containerCss = css`
  display: flex;
  flex-direction: column;
  height: 100vh;
`

const headerCss = css`
  position: relative;
  display: flex;
  justify-content: center;
  padding: 5px;
  background-color: white;
  color: ${PRIMARY_COLOR};
`

const logoCss = css`
  font-size: 2rem;
  color: black;
  object-fit: contain;
  font-family: 'Billabong', cursive;

  @media screen and (min-width: ${BREAK_POINT_PHONE_TAB}px){
    font-size: 3rem;
  }
`

const bodyCss = css`
  overflow-x: scroll;
  flex-grow: 1;
  position: relative;
`

const footerCss = css`
  width: 100%;
  display: flex;
  background-color: white;
  color: ${PRIMARY_COLOR};
`

const tabCss = css`
  padding: 15px;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (min-width: ${BREAK_POINT_PHONE_TAB}px){
    svg{
      height: 3rem;
      width: 3rem;
    }
  }
`

export default App;
